/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const t = {
  vertical: "top",
  horizontal: "left"
}, n = {
  vertical: "top",
  horizontal: "left"
}, l = {
  vertical: "top",
  horizontal: "right"
}, r = {
  vertical: "top",
  horizontal: "right"
}, o = {
  vertical: "flip",
  horizontal: "fit"
}, i = {
  vertical: "fit",
  horizontal: "flip"
}, a = {
  downward: {
    anchorAlign: {
      vertical: "bottom",
      horizontal: "right"
    },
    popupAlign: l,
    collision: o,
    animationDirection: "down"
  },
  leftward: {
    anchorAlign: {
      vertical: "top",
      horizontal: "left"
    },
    popupAlign: r,
    collision: i,
    animationDirection: "left"
  }
}, c = {
  downward: {
    anchorAlign: {
      vertical: "bottom",
      horizontal: "left"
    },
    popupAlign: t,
    collision: o,
    animationDirection: "down"
  },
  rightward: {
    anchorAlign: {
      vertical: "top",
      horizontal: "right"
    },
    popupAlign: n,
    collision: i,
    animationDirection: "right"
  }
};
export {
  c as POPUP_SETTINGS,
  a as POPUP_SETTINGS_RTL
};
